<template>
  <div
    class="video_preview--wrapper"
    @click="showVideo = true"
    v-if="!isSafari"
  >
    <img class="video_preview--poster" :src="options.poster" />
    <img
      class="video_preview--play_icon"
      src="https://src.leju.com/imp/imp/deal/db/2c/1/d3502b993a36b59223bf9548722_p122_mk169.png"
    />
  </div>
  <video
    v-else
    class="video--player"
    ref="playerRef"
    :poster="options.poster"
    :src="options.url"
    controls
    preload="auto"
    webkit-playsinline
    playsinline
    x5-video-player-type="h5-page"
    x-webkit-airplay="allow"
    x5-video-orientation="portraint"
    style="width: 100%; height: 100%; object-fit: cover"
    @playing="handlerOn('playing')"
    @ended="handlerOn('ended')"
    @pause="handlerOn('pause')"
  ></video>
  <Popup
    v-if="!isSafari"
    class="video_preview--popup"
    overlay-style="background-color: rgba(0,0,0,.95);"
    v-model:show="showVideo"
    teleport="body"
    style="width: 100vw"
  >
    <video
      class="video_preview--player"
      ref="playerRef"
      :src="options.url"
      controls
      preload="auto"
      webkit-playsinline
      playsinline
      autoplay
      x5-video-player-type="h5-page"
      x-webkit-airplay="allow"
      x5-video-orientation="portraint"
    ></video>
    <Icon
      name="close"
      class="video_preview--popup_close"
      @click="showVideo = false"
    />
  </Popup>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref, watch } from 'vue'
import { Popup, Icon } from 'vant'

export default defineComponent({
  name: 'Video',
  components: {
    Popup,
    Icon
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    on: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const playerRef = ref<null | HTMLVideoElement>(null)
    const showVideo = ref(false)
    const userAgent = window.navigator.userAgent
    const isSafari = /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)

    if (isSafari) {
      let isEnter = false
      const observer = new IntersectionObserver(
        intersections => {
          const intersection = intersections?.[0]
          if (playerRef.value && intersection) {
            if (intersection.isIntersecting) {
              isEnter = true
            } else if (isEnter) {
              isEnter = false
              setTimeout(() => {
                playerRef.value && playerRef.value.pause()
              })
            }
          }
        },
        { threshold: 1 }
      )
      onMounted(() => {
        if (playerRef.value) {
          observer.observe(playerRef.value)
        }
      })
      onUnmounted(() => {
        if (playerRef.value) {
          observer.unobserve(playerRef.value)
        }
      })
    } else {
      watch(showVideo, v => {
        if (playerRef.value) {
          v ? playerRef.value.play() : playerRef.value.pause()
        }
      })
    }

    return {
      isSafari,
      showVideo,
      playerRef,
      handlerOn(type: string) {
        props.on?.[type]?.()
      },
      getPlayer() {
        return playerRef
      }
    }
  }
})
</script>

<style lang="scss">
.video_preview--popup {
  background-color: rgba(0, 0, 0, 0);
  height: 100vh;
  display: flex;
  align-items: center;
  &.van-popup--center {
    top: 0;
    left: 0;
    transform: none;
  }
  .video_preview--player {
    width: 100%;
    height: 195px;
  }
  .video_preview--popup_close {
    position: absolute;
    bottom: 10%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 30px;
    color: #fff;
    z-index: 9999;
  }
}
</style>
<style lang="scss" scoped>
.video_preview--wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  .video_preview--poster {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .video_preview--play_icon {
    position: absolute;
    width: 54px;
    height: 54px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
